<template>
  <div class="simulation-main">
    <section class="simulation-select">
      <div class="c-inner">
        <h2 class="c-heading">シミュレーションの対象</h2>
        <div class="simulation-select__body">
          <template v-for="person in persons" :key="person.VALUE">
            <PersonForm
              :person="person"
              @update-condition="validatedPersons[person.ID] = $event"
            />
          </template>
        </div>
        <p class="simulation-select__note">
          最大４名までシミュレーション可能です。
        </p>
      </div>
    </section>
    <section class="simulation-lifestage">
      <div class="c-inner">
        <h2 class="simulation-lifestage__heading">ライフステージ</h2>
        <div class="simulation-lifestage__body">
          <ul class="simulation-lifestage__list">
            <template v-for="lifestage in lifestages" :key="lifestage.VALUE">
              <LifestageForm
                :lifestage="lifestage"
                @update-condition="validatedLifestage = $event"
              />
            </template>
          </ul>
          <nav class="simulation-start">
            <div v-show="validated">
              <img
                src="../assets/img/btn-start.png"
                class="simulation-start__btn"
                @click="move('options')"
              />
              <p class="simulation-start__text">「本人」のみ自動的におすすめプランが表示されます。<br>「配偶者」「こども」は必要な保障(補償)内容をご自身で選択してください。</p>
            </div>
            <transition>
              <p v-show="!validated" class="simulation-start__alert">
                性別・年齢・ライフステージを選択してください
              </p>
            </transition>
          </nav>
        </div>
      </div>
    </section>
  </div>
  <section class="l-backhome">
    <a href="/" class="c-btn c-btn--backhome">TOPに戻る</a>
  </section>
</template>

<script>
import PersonForm from "./PersonForm.vue";
import LifestageForm from "./LifestageForm.vue";
import { GENDER_LABELS, PERSON_LABELS, LIFESTAGE_LABELS } from "@/const.js";
import { mapMutations } from "vuex";

export default {
  name: "TheMain",
  components: {
    PersonForm,
    LifestageForm,
  },
  props: {},
  data() {
    return {
      validatedLifestage: false,
      validatedPersons: { p1: false, p2: false, p3: false, p4: false },
    };
  },
  computed: {
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    validated() {
      // console.log(this.validatedPersons);
      let validatedTemp = true;
      Object.keys(this.validatedPersons).forEach((key) => {
        // console.log("p:" + this.validatedPersons[key]);
        validatedTemp = validatedTemp && this.validatedPersons[key];
      });
      return this.validatedLifestage && validatedTemp;
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
  },
};
</script>

<style scoped lang="scss">
.simulation {
  &-select {
    background-color: $color-bg-main;
    &__body {
      @include pc {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 25px 0;
      }
    }
    &__note {
      @include pc {
        margin: 10px 0;
        font-size: 12px;
      }
      @include sp {
        font-size: 10px;
        text-align: center;
      }
    }
  }
  &-lifestage {
    position: relative;
    background-color: $color-bg-sub;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      display: block;
      border-top: 28px solid $color-bg-main;
      border-left: 52px solid transparent;
      border-right: 52px solid transparent;
    }
    &__heading {
      font-weight: 800;
      color: $color-red;
      @include pc {
        margin-bottom: 15px;
        font-size: 22px;
      }
      @include sp {
        margin-bottom: 10px;
        font-size: 18px;
      }
    }
    &__list {
      display: flex;
      justify-content: space-between;
      @include sp {
        flex-wrap: wrap;
      }
    }
  }
  &-start {
    @include pc {
      margin: 45px 0;
    }
    @include sp {
      margin-top: 20px;
    }
    &__btn {
      display: block;
      @include pc {
        width: 362px;
        margin: 0 auto;
      }
      &:hover {
        opacity: 0.7;
        cursor: pointer;
      }
    }
    &__text{
      margin: 20px 0;
      color: $color-text-black;
      font-weight: 800;
    }
    &__alert {
      text-align: center;
      margin-top: 20px;
      font-weight: 800;
      color: $color-red;
      @include pc {
        font-size: 20px;
      }
      @include sp {
        font-size: 14px;
      }
    }
  }
}
</style>